import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import CareerLayer from "../components/CareerLayer";

const CareerPage = () => {
  return (
    <MasterLayout>
      <CareerLayer />
    </MasterLayout>
  );
};

export default CareerPage;
